import { NgModule } from '@angular/core';

import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';

import { SharedModule } from '../shared/shared.module';

import { AppCollapsableComponent } from './app-collapsable/app-collapsable.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AppNavComponent } from './app-nav/app-nav.component';
import { PageContentComponent } from './page-content/page-content.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { AppPageNotFoundComponent } from './content/app-page-not-found/app-page-not-found.component';
import { AppAccessDeniedComponent } from './content/app-access-denied/app-access-denied.component';
import { AppSignedOutComponent } from './content/app-signed-out/app-signed-out.component';

import { GenericService } from '../service/GenericService.service';
import { AuthService } from '../auth/auth.service';
import { AuthGuard } from '../auth/auth.guard';
import { whitelist } from '../constants';
import { AuthStore } from '../auth/auth.store';


@NgModule({
  imports: [
    SharedModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [AuthService]
      }
    })
  ],
  declarations: [
    AppCollapsableComponent,
    AppHeaderComponent,
    AppNavComponent,
    PageContentComponent,
    PageHeaderComponent,
    AppPageNotFoundComponent,
    AppAccessDeniedComponent,
    AppSignedOutComponent
  ],
  exports: [
    AppCollapsableComponent,
    AppHeaderComponent,
    AppNavComponent,
    PageContentComponent,
    PageHeaderComponent,
    AppPageNotFoundComponent,
    AppAccessDeniedComponent,
    AppSignedOutComponent
  ],
  providers: [
    AuthGuard,
    AuthService,
    AuthStore,
    GenericService
  ]
})
export class CoreModule { }

export function jwtOptionsFactory(authService) {
  return {
    authScheme: '',
    tokenGetter: () => {
      return authService.getAsyncToken();
    },
    whitelistedDomains: whitelist
  };
}
